import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import { GetNotificationSettingDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

export const useFetchNotificationSetting = (open: boolean) => {
  const [getSetting, { called, loading, data }] = useLazyQuery(GetNotificationSettingDocument, {
    fetchPolicy: 'network-only',
  });
  const me = data ? getMe(data) : undefined;
  const setting = me?.organization.notificationSetting?.data;
  const organization = me?.organization;
  const isLightPlan = !!me?.organization.company.contractLightPlan;

  useEffect(() => {
    if (open) {
      getSetting();
    }
  }, [getSetting, open]);

  return {
    loading: !called || loading,
    isLightPlan,
    setting,
    organization,
  };
};
